import { Platform, Text, type StyleProp, type TextStyle } from "react-native";

export const SCREEN_TITLE_GRADIENT_BACKGROUND_STYLE = {
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.7' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)' opacity='0.06'/%3E%3C/svg%3E"), linear-gradient(135deg, #3B1A08 0%, #7A3E15 35%, #3B1A08 60%, #6B3410 85%, #3B1A08 100%)`,
  backgroundSize: "200px 200px, 100% 100%",
};

const WEB_GRADIENT_STYLE = {
  ...SCREEN_TITLE_GRADIENT_BACKGROUND_STYLE,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

type Props = {
  children: string;
  style?: StyleProp<TextStyle>;
};

export default function ScreenTitle({ children, style }: Props) {
  return (
    <Text
      accessibilityRole="header"
      className="font-dm-sans"
      style={[
        {
          fontSize: 38,
          fontWeight: "700",
          color: "#3B1A08",
          lineHeight: 42,
          letterSpacing: -0.5,
          ...(Platform.OS === "web" && WEB_GRADIENT_STYLE),
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}
